<template>
	<app-content class="h-panel">
		<div class="h-panel-bar"><span class="h-panel-title">站点设置</span></div>
		<div class="h-panel-body">
			<Row type="flex">
				<Cell :width="12">
					<Form :labelWidth="130" :model="form">
						<FormItem label="站点名称:">
							<input type="text" v-model="form.siteName" maxlength="128" placeholder="例如：纷析云"/>
						</FormItem>
						<FormItem label="Logo 路径:">
							<input type="text" v-model="form.logoPath" maxlength="500" placeholder="例如：/images/logo.png"/>
						</FormItem>
						<FormItem label="版权文字:">
							<input type="text" v-model="form.copyright" maxlength="500" placeholder="例如：Copyright © 2026 纷析云"/>
						</FormItem>
						<FormItem label="ICP 备案号:">
							<input type="text" v-model="form.icp" maxlength="128" placeholder="例如：京ICP备00000000号"/>
						</FormItem>
						<FormItem label="开放注册:">
							<Switch v-model="allowRegister"/>
						</FormItem>
						<FormItem label="注册默认账套数:">
							<input type="number" v-model.number="form.defaultAccountSetLimit" min="0" max="99"/>
						</FormItem>
						<FormItem label="客服二维码路径:">
							<input type="text" v-model="form.customerServiceQr" maxlength="500" placeholder="例如：/images/qr.png"/>
						</FormItem>
						<FormItem>
							<Button color="primary" :loading="saving" @click="save">保存</Button>
						</FormItem>
					</Form>
				</Cell>
			</Row>
		</div>
	</app-content>
</template>

<script>
	export default {
		name: "AdminSiteSettings",
		data() {
			return {
				loading: false,
				saving: false,
				form: {}
			}
		},
		computed: {
			allowRegister: {
				get() {
					return this.form.allowRegister === 1;
				},
				set(value) {
					this.$set(this.form, 'allowRegister', value ? 1 : 0);
				}
			}
		},
		methods: {
			loadConfig() {
				this.loading = true;
				this.$api.admin.getSiteSettings().then(({data}) => {
					this.form = data || {};
				}).finally(() => this.loading = false);
			},
			save() {
				this.saving = true;
				this.$api.admin.saveSiteSettings(this.form).then(() => {
					this.$Message.success('保存成功~');
					this.loadConfig();
				}).finally(() => this.saving = false);
			}
		},
		mounted() {
			this.loadConfig();
		}
	}
</script>
